export const getPageNumForCount = (recordCount: number, pageSize = 20) => {
	return Math.ceil(recordCount / pageSize);
};

export const getPaginationQueryString = ({
	baseQuery,
	newPage,
	pageSize,
	oldPage,
	beforeTs,
	afterTs,
}: {
	baseQuery: string;
	newPage: number;
	pageSize: number;
	oldPage?: number;
	beforeTs?: number;
	afterTs?: number;
}) => {
	const hasParamsAlready = baseQuery.includes('?');

	if (newPage < 0) {
		oldPage = undefined;
		beforeTs = undefined;
		afterTs = undefined;
	}

	return `${baseQuery}${
		hasParamsAlready ? '&' : '/?'
	}targetPageIndex=${newPage}&pageSize=${pageSize}${
		oldPage != undefined ? `&currPageIndex=${oldPage}` : ''
	}${beforeTs != undefined ? `&beforeTs=${beforeTs}` : ''}${
		afterTs != undefined ? `&afterTs=${afterTs}` : ''
	}`;
};
